import * as tslib_1 from "tslib";
import axios from 'axios';
import qs from 'query-string';
import JSONP from 'jsonp';
import ExtendableError from 'es6-error';
import { notification } from 'antd';
export class ApiError extends ExtendableError {
    constructor(message = '') {
        super(message);
    }
}
const noop = () => { };
const { protocol } = window.location;
const { CancelToken } = axios;
const handleRequestOption = (base, option) => (typeof option === 'function'
    ? (option(base) || base)
    : Object.assign({}, base, option));
const createAPI = (host, config = {}) => {
    const { showNotification = true } = config, base = tslib_1.__rest(config, ["showNotification"]);
    function request(endpoint, option) {
        const url = `${protocol}//${host}/${endpoint}`;
        let cancel = noop;
        const opts = handleRequestOption(Object.assign({}, base, { withCredentials: true, cancelToken: new CancelToken((c) => {
                cancel = c;
            }) }), option);
        const promise = axios(url, opts)
            .then(checkStatus)
            .then(resp => chekcResp(resp.data, url))
            .then(resp => resp.data)
            .catch((error) => {
            if (axios.isCancel(error)) {
                console.warn(`请求取消：${endpoint}`);
                return;
            }
            throw error;
        });
        return {
            promise,
            cancel,
        };
    }
    function checkStatus(resp) {
        if ((resp.status >= 200) && (resp.status < 300)) {
            return resp;
        }
        if (showNotification) {
            notification.error({
                message: `请求错误 ${resp.status}: ${resp.config.url}`,
                description: resp.statusText,
            });
        }
        throw new ApiError(`[${resp.status}] 请求错误 ${resp.config.url}`);
    }
    function chekcResp(data, url) {
        if (data.success) {
            return data;
        }
        if (showNotification) {
            notification.error({
                message: `请求失败 ${data.code}: ${url}`,
                description: data.msg,
            });
        }
        throw new ApiError(`[${data.code}] 请求失败 ${data.msg}`);
    }
    function getJson(endpoint, data, option) {
        return request(endpoint, Object.assign({}, handleRequestOption({ method: 'get', params: data }, option)));
    }
    function postJson(endpoint, data, option) {
        return request(endpoint, Object.assign({}, handleRequestOption({ method: 'post', data }, option)));
    }
    function postForm(endpoint, data, option) {
        return request(endpoint, Object.assign({}, handleRequestOption({ method: 'post', data: qs.stringify(data) }, option)));
    }
    function putJson(endpoint, data, option) {
        return request(endpoint, Object.assign({}, handleRequestOption({ method: 'put', data }, option)));
    }
    function patchJson(endpoint, data, option) {
        return request(endpoint, Object.assign({}, handleRequestOption({ method: 'patch', data }, option)));
    }
    function deleteJson(endpoint, data, option) {
        return request(endpoint, Object.assign({}, handleRequestOption({ method: 'delete', data }, option)));
    }
    function jsonp(endpoint) {
        return new Promise((resolve, reject) => {
            const url = `${protocol}//${host}/${endpoint}`;
            JSONP(url, { prefix: `__${host.replace(/[^\w\d]/g, '')}` }, (err, resp) => {
                if (err) {
                    reject(err);
                }
                else {
                    try {
                        chekcResp(resp, url);
                        resolve(resp.data);
                    }
                    catch (error) {
                        reject(error);
                    }
                }
            });
        });
    }
    return {
        request,
        getJson,
        postJson,
        postForm,
        putJson,
        patchJson,
        deleteJson,
        jsonp,
    };
};
export default createAPI;
